export interface IPageDTO<T> {
    content?: T []
    totalPages: number
    totalElements: number
}

export class PageModel<T> implements IPageDTO<T> {
  constructor(model?: Partial<IPageDTO<T>>) {
    if (model) {
      Object.assign(this, model);
    }
  }

  content: T []  = [];
  totalPages = 0;
  totalElements = 0;

}
